import script from "./BowlerProfileSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./BowlerProfileSummary.vue?vue&type=script&lang=ts&setup=true"

import "./BowlerProfileSummary.vue?vue&type=style&index=0&id=2da55078&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da55078"]])

export default __exports__